
import { getQSObject, getValueOfQSObject} from '../qsUtils'

export const getCurrentFormatByURL = () => {
  let format = 'HWP';
  try {
    const hostsplited = window.location.hostname.split('.');
    if (hostsplited.length === 3) {
      switch (hostsplited[0]) {
        case 'vf-webeditor':
        case 'hwp':
          format = 'HWP';
          break;
        case 'vf-websheet':
        case 'sheet':
          format = 'SHEET';
          break;
        case 'vf-webslide':
        case 'slide':
          format = 'SLIDE';
          break;
        case 'vf-webword':
        case 'word':
          format = 'WORD';
          break;
        default:
          break;
      }
    }
  } catch (error) {
  } finally {
    return format;
  }
};

export const getCurrentFormatByPath = (location,pos) => {
  let format = 'HWP';
  try {
    const posInt = parseInt(pos);
    const locationObj = location ||  window.location;
    switch ( locationObj.pathname.split('/')[posInt]) {
      case 'hwp':
        format = 'HWP';
        break;
      case 'sheet':
        format = 'SHEET';
        break;
      case 'slide':
        format = 'SLIDE';
        break;
      case 'word':
        format = 'WORD';
        break;
      default:
        break;
    }
  } catch (error) {
  } finally {
    return format;
  }
};

export const getCurrentFormatByQuery = (queryName) => {
  let format = 'HWP';
  try {
    const qsObject = getQSObject();

    const formatType = getValueOfQSObject(qsObject, queryName);

    switch (formatType) {
      case 'hwp':
        format = 'HWP';
        break;
      case 'sheet':
        format = 'SHEET';
        break;
      case 'slide':
        format = 'SLIDE';
        break;
      case 'word':
        format = 'WORD';
        break;
      default:
        break;
    }
  } catch (error) {
  } finally {
    return format;
  }
};
